import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Texture } from "pixi.js";
export class CheckoutsTooltipResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("CheckoutsTooltipResourcePackage");
    }
    public get assets_views_checkouts_tooltip_tooltip_base_variant3_png(): Texture {
        return this.resource<Texture>("assets/views/checkouts_tooltip/tooltip_base_variant3.png");
    }
    public get assets_views_checkouts_tooltip_tooltip_union_variant1_png(): Texture {
        return this.resource<Texture>("assets/views/checkouts_tooltip/tooltip_union_variant1.png");
    }
}

